import {
    Box,
    Button,
    Grid,
    InputAdornment,
    TextField,
} from '@mui/material';
import { Add, SearchOutlined } from '@mui/icons-material';
import { DocumentTypeControllerAction, DocumentTypeControllerState } from '../../controller/document.type.controller';


interface IProps {
    ctrl: DocumentTypeControllerState & DocumentTypeControllerAction
    handleOpenDialog: () => void;
}

const DocumentTypeHeader = ({ handleOpenDialog, ctrl }: IProps) => {

    return (
        <Box sx={{ py: 3, px: 3 }}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={3}>
                    <TextField
                        value={ctrl.filter?.search ?? ''}
                        onChange={(e) => {
                            if (e.target.value.length > 0 && e.target.value.trim() !== "") {
                                ctrl.onFilterChange({ ...ctrl.filter, search: e.target.value });
                            } else {
                                const updated = { ...ctrl.filter };
                                delete updated.search;
                                ctrl.onFilterChange(updated);
                            }
                        }}
                        size="small"
                        placeholder="ປ້ອນປະເພດເອກະສານ"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchOutlined />
                                </InputAdornment>
                            ),
                            style: {
                                borderRadius: '30px',
                            },
                        }}
                        fullWidth
                    />
                </Grid>
                <Box flex={1} />
                <Grid
                    item
                    xs={12}
                    md={3}
                    sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}
                >
                    <Button
                        variant="contained"
                        sx={{ width: { md: '84%', xs: '100%' }, borderRadius: 5 }}
                        onClick={handleOpenDialog}
                        fullWidth
                    >
                        <Add /> ເພີ່ມປະເພດເອກະສານ
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DocumentTypeHeader;
